<div class="modal fade" id="unsavedChangesModal" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Unsaved Changes</h5>
        <button type="button" class="close unsavedChangesStay" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>There are unsaved changes on the page.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light unsavedChangesStay" data-dismiss="modal">Stay</button>
        <button id="unsavedChangesDiscard" type="button" class="btn btn-warning" data-dismiss="modal">Discard
          Changes</button>
        <button id="saveChangesAndContinue" type="button" class="btn btn-success" data-dismiss="modal" style="display: none;">Save And
          Continue</button>
      </div>
    </div>
  </div>
</div>